/**
 * Littlemore Marquee Custom Element
 * Clones track children for seamless CSS animation loop.
 * Respects prefers-reduced-motion.
 */
class LittlemoreMarquee extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('[data-marquee-track]');
    if (!track) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      track.style.animationPlayState = 'paused';
      return;
    }

    const clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    this.appendChild(clone);

    this.addEventListener('mouseenter', () => {
      this.querySelectorAll('[data-marquee-track]').forEach((t) => {
        t.style.animationPlayState = 'paused';
      });
    });

    this.addEventListener('mouseleave', () => {
      this.querySelectorAll('[data-marquee-track]').forEach((t) => {
        t.style.animationPlayState = 'running';
      });
    });

    // Touch pause for mobile
    let touchResumeTimer = null;
    this.addEventListener('touchstart', () => {
      if (touchResumeTimer) {
        clearTimeout(touchResumeTimer);
        touchResumeTimer = null;
      }
      this.querySelectorAll('[data-marquee-track]').forEach((t) => {
        t.style.animationPlayState = 'paused';
      });
    }, { passive: true });

    this.addEventListener('touchend', () => {
      touchResumeTimer = setTimeout(() => {
        this.querySelectorAll('[data-marquee-track]').forEach((t) => {
          t.style.animationPlayState = 'running';
        });
        touchResumeTimer = null;
      }, 3000);
    }, { passive: true });
  }
}

customElements.define('littlemore-marquee', LittlemoreMarquee);
